<template>
  <v-app>
    <v-app-bar app>
      <img
        :src="logo"
        height="40"
      >
      <router-link to="/">
        <v-app-bar-title class="ml-3 font-weight-bold black--text">月票繳費服務平台</v-app-bar-title>
      </router-link>

      <v-spacer></v-spacer>
      <v-menu  transition="slide-y-transition"  offset-y>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-show="loginState"
            v-bind="attrs"
            v-on="on"
          >
          <v-icon dark>
            mdi-account
          </v-icon>
        </v-btn>
      </template>
      <v-list>
        <v-list-item>
          <v-btn
            text
            color="primary"
            @click="changePWDDialog = true"
          >變更密碼</v-btn>
        </v-list-item>
        <v-list-item>
          <v-btn
            text
            color="error"
            @click="logout"
          >登出</v-btn>
        </v-list-item>
      </v-list>
    </v-menu>
    </v-app-bar>

    <v-main>
      <snackbar />
      <router-view />
    </v-main>

    <v-dialog
      v-model="changePWDDialog" transition="dialog-bottom-transition" max-width="600px" persistent
    >
    <v-card>
        <v-toolbar dark color="primary">
          <v-toolbar-title>變更密碼</v-toolbar-title>
          <v-spacer />
          <v-btn v-if="canCancel" icon dark @click="cancelchangePWD">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <v-form ref="verifyChangePWD" v-model="verifyChangePWD" @submit.prevent="submitChangePwd()">
            <v-row class="d-flex d-sm-none mt-3 text-h6">
              <v-col cols="12">請輸入以下資訊</v-col>
            </v-row>
            <v-row justify="center">
              <v-col cols="12" sm="6" md="6">
              <v-text-field v-model="changePWDModel.OriPassword" :rules="[(v) => !!v || '必填項目']"
                                    label="原始密碼" type="password" required></v-text-field>
              </v-col>
            </v-row>
            <v-row justify="center">
              <v-col cols="12" sm="6" md="6">
                  <v-text-field v-model="changePWDModel.Password" :rules="[(v) => !!v || '必填項目', (v) => (v || '').length >= 8 || '最少長度為8碼']"
                                    label="新密碼" :type="changePWDType" required :append-icon="changePWDIcon" @click:append="showChangePWD"></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="6">
              <v-text-field v-model="checkNewPWD" :rules="[(v) => !!v || '必填項目', (v) => (v || '') === changePWDModel.Password || '密碼不一致']"
                                    label="確認新密碼" type="password" required></v-text-field>
              </v-col>
            </v-row>
            <v-row justify="center">
              <v-col v-if="canCancel" cols="4" md="4">
                <v-btn block class="mt-3 mb-1" type="button" @click="cancelchangePWD">取消</v-btn>
              </v-col>
              <v-col cols="4" md="4">
                <v-btn block color="primary" class="mt-3 mb-1" type="submit">送出</v-btn>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-footer
      color="primary"
      padless
    >
      <v-card
        flat
        tile
        class="flex indigo lighten-1 white--text text-center"
      >
        <v-card-text class="primary lighten-2 white--text">
          俥亭停車事業股份有限公司/日月亭股份有限公司/宜舍企業股份有限公司/日月商場股份有限公司
        </v-card-text>
        <v-card-text class="primary lighten-2 white--text pt-0 pb-0">
          <v-row
            justify="center"
            no-gutters
          >
            <v-col
              class="text-center white--text"
              cols="12"
            >
              聯絡資訊: 115-025 台北市南港區忠孝東路六段66號1樓
            </v-col>
            <v-col
              class="text-center white--text"
              cols="12"
            >
              客服電話:0800-021-111
            </v-col>
            <v-col
              class="text-center white--text"
              cols="12"
            >
              E-Mail:park_service@youparking.com.tw
            </v-col>
          </v-row>
        </v-card-text>

        <v-card-text class="white--text">
          <v-icon
            dark
            small
          >mdi-copyright</v-icon> <strong>九亭股份有限公司 All Rights Reserved</strong>
        </v-card-text>
      </v-card>
    </v-footer>
    <overlay />
  </v-app>
</template>

<script>
import Snackbar from '@/components/Snackbar.vue';
import Overlay from '@/components/Overlay.vue';
import logo from './assets/pcc_logo.png';

export default {
  name: 'App',
  components: {
    Snackbar,
    Overlay
  },
  data: () => ({ 
    logo,
    changePWDDialog: false, 
    verifyChangePWD: false,
    changePWDModel: {
        OriPassword: null,
        Password: null
    },
    checkNewPWD: '',
    changePWDIcon: 'mdi-eye-off',
    changePWDType: 'password',
  }),
  computed: {
    loginState () {
      return this.$store.state.loginstatus.status;
    },
    canCancel () {
      return this.$store.state.loginstatus.changePWD == false;
    },
  },
  watch: {
    loginState: {
      handler: function (newValue) {
        if (newValue == true && this.canCancel == false) {
          this.changePWDDialog = true;
        }
      }
    }
  },
  methods: {
    logout() {
      this.dbio('/Auth', {}, 'delete').then(() => {
        this.$store.dispatch("loginstatus/setLoginStatus", {status: false});
        this.$router.push({ name: 'Login' });
      });
    },
    showChangePWD(){
      if (this.changePWDType == 'password') {
            this.newPwdType = 'text'
            this.changePWDType = 'mdi-eye-outline';
        } else {
            this.changePWDType = 'password'
            this.changePWDIcon = 'mdi-eye-off';
        }
    },
    submitChangePwd() {
      this.$refs.verifyChangePWD.validate();
      if (this.verifyChangePWD) {
        const requset = {
            OriPassword: this.changePWDModel.OriPassword,
            Password: this.changePWDModel.Password,
          }
        this.dbio('/Auth/ChangePWD', requset, 'post').then((response) => {
          if(response.Success) {
              this.cancelchangePWD();
              this.msg("更改成功，請使用新密碼登入", 5000, 'primary');
              this.logout();
          } else {
            this.msg(response.ReturnMsg, 5000);
          }
        });
      }
    },
    cancelchangePWD() {
      this.$refs.verifyChangePWD.reset();
      this.changePWDModel =  {
          OriPassword: null,
          Password: null
        };
      this.checkNewPWD = null;
      this.changePWDDialog = false;
    },
  }
};
</script>
